import { OnlineOrderPayload, ProceedPaymentI, razorPayProcessI } from "../Interface/Payment.interface";
import { axiosInstance } from "./Api";


const paymentService ={

    ProceedPayment: async(payload:ProceedPaymentI):Promise<any> =>{
        
        const response= await axiosInstance.post('/POS/InitiatePayment',payload)
        return response.data;
    },

    ConfirmPayment: async(payload:razorPayProcessI):Promise<any> =>{
        
        const response= await axiosInstance.post('POS/CompletePayment',JSON.stringify(payload))
        return response.data;
    },

    SaveOrders : async(payload:OnlineOrderPayload):Promise<any> =>{
        
        const response = await axiosInstance.post('EcomHome/SaveOnlineorder',payload)
        return response.data;
    }
}


export default paymentService